export const SUJETS_BOUSSOLE = [
    {
        id: 'inviter-parent',
        titre: 'Comment inviter l’autre parent ?',
        motsCles: ['inviter', 'invitation', 'rejoindre', 'autre parent', 'ajouter un parent'],
        reponse: 'Depuis le dossier, la carte « Enfants » propose d’inviter l’autre parent : vous saisissez son adresse e-mail, il reçoit un lien et rejoint le même dossier. Tant qu’il n’a pas rejoint, ce que vous écrivez reste enregistré et lui sera visible à son arrivée.',
        categorie: 'enfants',
    },
    {
        id: 'schema-garde',
        titre: 'Comment poser ou changer le schéma de garde ?',
        motsCles: [
            'schema',
            'garde',
            'alternance',
            'semaine alternee',
            'week-ends alternes',
            'rythme',
            'residence',
            'changer la garde',
        ],
        reponse: 'Le schéma se choisit à la création du dossier, puis se modifie dans le calendrier. Un changement n’efface pas le passé : l’ancien schéma reste lisible dans l’historique, avec sa date de fin. C’est ce qui permet de dire, des mois plus tard, quel rythme s’appliquait à une date donnée.',
        categorie: 'calendrier',
    },
    {
        id: 'qui-a-enfant',
        titre: 'Comment savoir chez qui est l’enfant ce soir ?',
        motsCles: ['chez qui', 'ce soir', 'aujourd hui', 'qui a', 'qui garde', 'ou est'],
        reponse: 'L’écran « Aujourd’hui » répond en une ligne, et le calendrier montre les jours suivants. Les deux se calculent à partir du schéma en vigueur et des échanges acceptés — ils disent donc toujours la même chose.',
        categorie: 'aujourdhui',
    },
    {
        id: 'demander-echange',
        titre: 'Comment demander un échange de jours ?',
        motsCles: [
            'echange',
            'echanger',
            'echange de jours',
            'permuter',
            'inverser',
            'demande',
            'proposition',
            'derogation',
        ],
        reponse: 'Dans le calendrier, choisissez les jours concernés puis « Demander un échange ». L’autre parent reçoit la demande et l’accepte ou la refuse ; tant qu’il n’a pas répondu, le calendrier continue d’afficher le schéma habituel. Un échange accepté devient une dérogation, visible comme telle sur les jours qu’il déplace.',
        categorie: 'calendrier',
    },
    {
        id: 'declarer-depense',
        titre: 'Comment déclarer une dépense ?',
        motsCles: ['depense', 'declarer', 'facture', 'ticket', 'justificatif', 'achat', 'frais'],
        reponse: 'Dans « Dépenses », indiquez le montant, la catégorie et la date de la dépense — c’est cette date, et non celle de la saisie, qui détermine la clé de répartition appliquée. Le justificatif est facultatif : une dépense reste déclarable sans son ticket.',
        categorie: 'depenses',
    },
    {
        id: 'repartition',
        titre: 'Comment se calcule le partage des dépenses ?',
        motsCles: [
            'repartition',
            'partage',
            'partage des depenses',
            'cle de repartition',
            'pourcentage',
            'moitie',
            'qui paye',
        ],
        reponse: 'Une clé de répartition fixe la part de chaque parent, globalement ou par catégorie. Elle se propose et s’accepte, elle ne s’impose pas. Chaque version porte sa date d’entrée en vigueur : les dépenses passées gardent la clé qui s’appliquait à leur date.',
        categorie: 'depenses',
    },
    {
        id: 'contester-depense',
        titre: 'Que se passe-t-il si je conteste une dépense ?',
        motsCles: [
            'conteste',
            'conteste une depense',
            'contester une depense',
            'contestation',
            'refuser',
            'desaccord',
            'pas d accord',
        ],
        reponse: 'Une contestation demande un motif : un refus sans explication ne fait qu’arrêter la discussion. La dépense reste inscrite, marquée comme contestée, avec le motif — rien n’est effacé, et l’export montrera les deux positions.',
        categorie: 'depenses',
    },
    {
        id: 'solde',
        titre: 'Comment lire le solde entre parents ?',
        motsCles: ['solde', 'combien', 'doit', 'remboursement', 'rembourser', 'equilibre', 'compte'],
        reponse: 'Le solde additionne les dépenses acceptées selon la clé applicable à chacune, puis retire les remboursements déclarés. Il dit un écart, pas une dette exigible : c’est un outil de conversation, pas un titre de paiement.',
        categorie: 'depenses',
    },
    {
        id: 'messagerie',
        titre: 'À quoi sert la messagerie ?',
        motsCles: ['message', 'messagerie', 'ecrire', 'discussion', 'conversation', 'reformuler'],
        reponse: 'Elle garde les échanges liés aux enfants au même endroit que le reste du dossier, horodatés et inaltérables. Repère n’indique jamais la présence de l’autre parent, ni qu’un message vient d’être lu : cette absence est un choix de produit, pas un manque.',
        categorie: 'messages',
    },
    {
        id: 'urgence',
        titre: 'Comment signaler une urgence ?',
        motsCles: ['urgence', 'urgent', 'alerte', 'imprevu', 'accident', 'malade'],
        reponse: 'Le bouton d’urgence dépose une alerte : motif choisi dans une liste courte, texte bref, notification immédiate à l’autre parent, même la nuit. Au-delà de deux urgences en 24 heures, le dépôt suivant part comme message dans le fil « Urgences » — une alerte qui sonne tout le temps ne réveille plus personne.',
        categorie: 'aujourdhui',
    },
    {
        id: 'journal',
        titre: 'À quoi sert le journal ?',
        motsCles: ['journal', 'consigner', 'noter', 'evenement', 'historique', 'trace'],
        reponse: 'Le journal consigne des faits datés — un rendez-vous médical, un retard, une remise d’affaires. Il n’envoie aucune notification : y écrire n’est pas s’adresser à l’autre parent, c’est tenir sa propre trace.',
        categorie: 'journal',
    },
    {
        id: 'export',
        titre: 'Comment obtenir un export du dossier ?',
        motsCles: ['export', 'exporter', 'pdf', 'avocat', 'juge', 'preuve', 'telecharger', 'dossier complet'],
        reponse: 'L’export produit un PDF daté de tout ce que contient le dossier, avec les empreintes qui permettent de vérifier que rien n’a été modifié après coup. Sa préparation prend quelques minutes ; un lien de téléchargement vous est remis quand il est prêt.',
        categorie: null,
    },
    {
        id: 'fiche-enfant',
        titre: 'Que met-on dans la fiche d’un enfant ?',
        motsCles: ['fiche', 'enfant', 'avatar', 'prenom', 'taille', 'pointure', 'allergie', 'ecole', 'medecin'],
        reponse: 'La fiche rassemble ce dont les deux parents ont besoin sans avoir à se le redemander : école, médecin, allergies, tailles, personnes autorisées. Elle est partagée — ce que l’un corrige, l’autre le voit, et la correction est datée.',
        categorie: 'enfants',
    },
    {
        id: 'abonnement',
        titre: 'Que change l’abonnement ?',
        motsCles: ['abonnement', 'payer', 'prix', 'tarif', 'gratuit', 'souscrire', 'resilier', 'facture mensuelle'],
        reponse: 'La version gratuite laisse tout lire et consulter ; l’abonnement ouvre l’écriture et l’export. Ce qui a déjà été enregistré reste lisible quoi qu’il arrive, y compris après une résiliation : un dossier n’est pas repris à celui qui l’a constitué.',
        categorie: null,
    },
    {
        id: 'notifications',
        titre: 'Comment régler les notifications ?',
        motsCles: ['notification', 'alerte mail', 'e-mail', 'push', 'nuit', 'silence', 'prevenu'],
        reponse: 'Les notifications se règlent dans votre compte, avec des heures silencieuses : ce qui naît la nuit est remis au matin. Seule une urgence traverse le silence, et c’est la seule exception.',
        categorie: null,
    },
    {
        id: 'supprimer-dossier',
        titre: 'Comment supprimer un dossier ?',
        motsCles: [
            'supprimer un dossier',
            'supprimer le dossier',
            'effacer un dossier',
            'fermer un dossier',
            'archive',
            'archiver',
            'annuler la suppression',
            'restaurer un dossier',
        ],
        reponse: "Depuis l'onglet « Aujourd'hui » du dossier, tout en bas : « Supprimer ce dossier ». " +
            "La suppression se décide à deux — l'autre parent reçoit un message et doit la valider ; " +
            'si vous êtes seul sur le dossier, ce message vous est adressé. Une fois validée, le ' +
            'dossier est archivé trente jours : il reste consultable et exportable, mais plus ' +
            "personne ne peut y écrire. Au terme des trente jours, il est détruit définitivement. " +
            "Pendant tout ce délai, l'un comme l'autre peut annuler la suppression d'un clic, " +
            'depuis le dossier.',
        categorie: 'aujourdhui',
    },
    {
        id: 'donnees',
        titre: 'Que deviennent mes données ?',
        motsCles: ['donnee', 'rgpd', 'confidentialite', 'chiffrement', 'supprimer mon compte', 'securite', 'heberge'],
        reponse: 'Les dossiers sont chiffrés et hébergés en France. Vous pouvez demander une copie de vos données ou la suppression de votre compte depuis les réglages de confidentialité. Les écritures déjà versées au dossier partagé, elles, restent : leur inaltérabilité est ce qui leur donne leur valeur pour les deux parents.',
        categorie: null,
    },
];
//# sourceMappingURL=sujets.js.map